import { PINNED_NAMES } from './constants'

const RANK_COLORS = ['#7a001c', '#b5002a', '#cc2244', '#e05572', '#eb8fa2', '#f5c5d0']

export function buildRows(data, nameKey) {
    if (!data || data.length === 0) return []

    const isPinned     = d => !d[nameKey] || PINNED_NAMES.test(String(d[nameKey]).trim()) || Number(d.amount) === 0
    const pinned       = data.filter(isPinned)
    const normal       = data.filter(d => !isPinned(d))

    const sorted       = [...normal].sort((a, b) => Number(b.amount) - Number(a.amount))
    const top          = sorted.slice(0, sorted.length <= 6 ? 6 : 5)
    const rest         = sorted.slice(top.length)

    if (rest.length > 0) {
        top.push({
            [nameKey]: 'Others',
            amount: rest.reduce((s, d) => s + Number(d.amount || 0), 0),
            _isOther: true,
            _isAggregate: true,
        })
    }

    const pinnedSorted = [...pinned].sort((a, b) => Number(b.amount) - Number(a.amount))
    pinnedSorted.forEach(d => { d._isOther = true })

    const rows  = [...top, ...pinnedSorted]
    const total = rows.reduce((s, d) => s + Number(d.amount || 0), 0)
    const max   = Math.max(...rows.map(d => Number(d.amount) || 0), 1)

    return rows.map((d, i) => {
        const amt      = Number(d.amount) || 0
        const rawPct   = total > 0 ? (amt / total) * 100 : 0
        const pctLabel = amt === 0 ? (d._isAggregate ? '0%' : 'Undisclosed') : rawPct < 0.1 ? '<0.1%' : rawPct.toFixed(1) + '%'
        const barWidth = parseFloat(((amt / max) * 100).toFixed(2))
        return {
            name: d[nameKey] || 'N/A',
            amount: amt,
            pctLabel,
            barWidth,
            labelInside: barWidth >= 10,
            color: d._isOther ? '#adb5bd' : (RANK_COLORS[i] || RANK_COLORS[RANK_COLORS.length - 1]),
            isOther: !!d._isOther,
        }
    })
}
